import { render, staticRenderFns } from "./AutoUpdateSettingsCard.vue?vue&type=template&id=79d2823e&scoped=true"
import script from "./AutoUpdateSettingsCard.vue?vue&type=script&lang=js"
export * from "./AutoUpdateSettingsCard.vue?vue&type=script&lang=js"
import style0 from "./AutoUpdateSettingsCard.vue?vue&type=style&index=0&id=79d2823e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d2823e",
  null
  
)

export default component.exports